import { PERMISSOES, validarPermissoes } from '../utils/PermissaoUtils';
import { APP_ROUTES } from './app_routes';

/**
 * Classe responsável por gerenciar os itens de menu da aplicação
 */
class MenuService {
  // Definição de módulos e suas configurações
  static MODULOS = {
    CLIENTE: {
      id: "cliente",
      nome: "CLIENTE",
      rotaVisualizacao: APP_ROUTES.CLIENTE_VISUALIZAR,
      rotaCadastro: APP_ROUTES.CLIENTE_CADASTRO,
      rotaEdicao: APP_ROUTES.CLIENTE_EDITAR,
      tipo: "cadastro"
    },
    EMPRESA: {
      id: "empresa",
      nome: "EMPRESA",
      rotaVisualizacao: APP_ROUTES.EMPRESA_VISUALIZAR,
      rotaCadastro: APP_ROUTES.EMPRESA_CADASTRO,
      rotaEdicao: APP_ROUTES.EMPRESA_EDITAR,
      tipo: "cadastro"
    },
    USUARIO: {
      id: "usuario",
      nome: "USUARIO",
      rotaVisualizacao: APP_ROUTES.USUARIO_VISUALIZAR,
      rotaCadastro: APP_ROUTES.USUARIO_CADASTRO,
      rotaEdicao: APP_ROUTES.USUARIO_EDITAR,
      tipo: "cadastro"
    },
    CHAVES: {
      id: "chaves",
      nome: "CHAVES API",
      rotaVisualizacao: APP_ROUTES.DESENVOLVIMENTO_CHAVES,
      rotaCadastro: APP_ROUTES.DESENVOLVIMENTO_CHAVES_CADASTRO,
      rotaEdicao: APP_ROUTES.DESENVOLVIMENTO_CHAVES_EDITAR,
      tipo: "cadastro"
     },
    BANCO: {
      id: "banco",
      nome: "BANCO",
      rotaVisualizacao: APP_ROUTES.BANCO_VISUALIZAR,
      tipo: "cadastro",
      somenteDev: true
    },
    LISTA_EQUIPAMENTOS: {
      id: "equipamento",
      nome: "LISTA DE EQUIPAMENTOS",
      rotaVisualizacao: APP_ROUTES.EQUIPAMENTO_VISUALIZAR,
      tipo: "equipamento"
    },
    RELATORIO_AUDITORIA: {
      id: "relatorio_auditoria",
      nome: "AUDITORIA",
      rotaVisualizacao: APP_ROUTES.RELATORIO_AUDITORIA,
      tipo: "relatorio"
    },
  };

  /**
   * Retorna o nome da permissão de listagem para o módulo
   * @param {string} idModulo
   */
  static getPermissaoListar(idModulo) {
    switch (idModulo) {
      case 'cliente':
        return PERMISSOES.CLIENTE_LISTAR;
      case 'empresa':
        return PERMISSOES.EMPRESA_LISTAR;
      case 'usuario':
        return PERMISSOES.USUARIO_LISTAR;
      case 'chaves':
          return PERMISSOES.APIKEY_LISTAR;
      case 'equipamento':
        return PERMISSOES.EQUIPAMENTO_LISTAR;
      case 'relatorio_auditoria':
        return PERMISSOES.AUDITORIA_LISTAR;
      case 'banco':
        return PERMISSOES.CLIENTE_LISTAR;
      default:
        return null;
    }
  }

  
  static getSubmenuCadastro() {
    const submenus = Object.values(this.MODULOS)
      .filter(modulo => modulo.tipo === "cadastro")
      .filter(modulo => {
        const permissao = this.getPermissaoListar(modulo.id);
        return permissao ? validarPermissoes(permissao) : true;
      })
      .map(modulo => ({
        id: modulo.id,
        nome: modulo.nome,
        rota: modulo.rotaVisualizacao,
        somenteDev: modulo.somenteDev || false
      }));
      return submenus;
  }

  static getSubmenuEquipamento() {
    return Object.values(this.MODULOS)
      .filter(modulo => modulo.tipo === "equipamento")
      .filter(modulo => {
        const permissao = this.getPermissaoListar(modulo.id);
        return permissao ? validarPermissoes(permissao) : true;
      })
      .map(modulo => ({
        id: modulo.id,
        nome: modulo.nome,
        rota: modulo.rotaVisualizacao
      }));
  }
  
  static getSubmenuRelatorio() {
    return Object.values(this.MODULOS)
      .filter(modulo => modulo.tipo === "relatorio")
      .filter(modulo => {
        const permissao = this.getPermissaoListar(modulo.id);
        return permissao ? validarPermissoes(permissao) : true;
      })
      .map(modulo => ({
        id: modulo.id,
        nome: modulo.nome,
        rota: modulo.rotaVisualizacao
      }));
  }


  static getAllSubmenus() {
    return {
      cadastro: this.getSubmenuCadastro(),
      equipamento: this.getSubmenuEquipamento(),
      relatorio: this.getSubmenuRelatorio(),
    };
  }

  static getCadastroModules() {
    return new Set(this.getSubmenuCadastro().map(item => item.id));
  }

  static getEquipamentoModules() {
    return new Set(this.getSubmenuEquipamento().map(item => item.id));
  }

  static getRelatorioModules() {
    return new Set(this.getSubmenuRelatorio().map(item => item.id));
  }

  static isValidModule(moduleId) {
    return [...this.getCadastroModules(), ...this.getEquipamentoModules(), ...this.getRelatorioModules()].includes(moduleId);
  }

  static getModuloPorId(id, tipo) {
    return Object.values(this.MODULOS)
      .find(modulo => modulo.id === id && modulo.tipo === tipo);
  }

  static getRotaVisualizacao(id, tipo) {
    const modulo = this.getModuloPorId(id, tipo);
    return modulo ? modulo.rotaVisualizacao : null;
  }

  static getRotaCadastro(id, tipo) {
    const modulo = this.getModuloPorId(id, tipo);
    return modulo ? modulo.rotaCadastro : null;
  }

  static getRotaEdicao(id, tipo) {
    const modulo = this.getModuloPorId(id, tipo);
    return modulo ? modulo.rotaEdicao : null;
  }
}

export default MenuService;
